import { AxiosResponse } from 'axios';

import apiClient from './client';
import i18n from 'i18n';
import { ApiResponseDto } from 'interfaces/apiResponse';

export interface TenantInvoicingConfigDto {
  id: number;
  eligibleOrderStatuses: string[];
  autoGenerateDraft: boolean;
  defaultInvoiceSeriesId: number | null;
  aadeUserId: string | null;
  hasAadeSubscriptionKey: boolean;
}

export interface TenantInvoicingConfigUpdateRequest {
  eligibleOrderStatuses: string[];
  autoGenerateDraft: boolean;
  defaultInvoiceSeriesId: number | null;
  aadeUserId: string | null;
  aadeSubscriptionKey: string | null;
  clearAadeCredentials?: boolean;
}

interface InvoicingConfigService {
  getConfig(): Promise<TenantInvoicingConfigDto>;
  updateConfig(data: TenantInvoicingConfigUpdateRequest): Promise<TenantInvoicingConfigDto>;
}

const endpoints = {
  config: '/tenant/invoicing/config',
};

export const invoicingConfigService: InvoicingConfigService = {
  getConfig: async (): Promise<TenantInvoicingConfigDto> => {
    const response: AxiosResponse<ApiResponseDto<TenantInvoicingConfigDto>> = await apiClient.get(endpoints.config);

    if (response.data.errors) {
      throw new Error(response.data.errors.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },

  updateConfig: async (data: TenantInvoicingConfigUpdateRequest): Promise<TenantInvoicingConfigDto> => {
    try {
      const response: AxiosResponse<ApiResponseDto<TenantInvoicingConfigDto>> = await apiClient.put(endpoints.config, data);

      if (response.data.errors) {
        throw new Error(response.data.errors.map(error => error.message).join(', '));
      }

      return response.data.data!;
    } catch (error: any) {
      if (error.response?.data?.errors) {
        const firstError = error.response.data.errors[0];

        if (firstError.code === 'AADE_CREDENTIALS_INVALID') {
          throw new Error(i18n.t('apiErrors.aadeCredentialsInvalid'));
        }

        throw new Error(firstError.message);
      }

      throw error;
    }
  },
};
